import React, { useCallback, useMemo } from "react";
import { PhoneInput, defaultCountries, parseCountry } from "react-international-phone";

import * as validate from '../../utils/phoneValidation';
import { ALLOWED_COUNTRIES } from "../../utils/flagsConfig";

import "./InternationalPhoneInput.css";
import "../../css/common-forms.css";

/* ---------------- Component ---------------- */

const InternationalPhoneInput = ({
  containerClassName = "",
  value,
  iso,
  nationalNumber,
  error,
  styles,
  onChange,
  onFocus,
  onBlur,
  placeholderMode = "none",
  disabled
}) => {

  const countries = useMemo(() =>
    defaultCountries.filter((country) => {
      const { iso2 } = parseCountry(country);
      return ALLOWED_COUNTRIES.includes(iso2);
    }),
    []
  );

  const normalizedCountry = useMemo(
    () => validate.normalizeCountryCode(iso),
    [iso]
  );

  const defaultCountry = ALLOWED_COUNTRIES.includes(normalizedCountry) ? normalizedCountry : "us";

  const numberValue =
    value && typeof value === "string" && value.startsWith("+")
      ? value
      : `+${defaultCountry === "us" ? "1" : ""}`;

  const placeholderText = useMemo(
    () => validate.getPhonePlaceholderByCountry(defaultCountry),
    [defaultCountry]
  );

  const showHelperText = placeholderMode === "helperText";

  const handleChange = useCallback(
    (val, meta) => {
      if (disabled) {
        return;
      }
      onChange(validate.parsePhoneInput(val, meta));
    },
    [onChange]
  );

  const wrapperClass = `${containerClassName} ${ placeholderMode === "TemplateSendExampleNumber" ? styles.floatingLabelWrapperNumber : styles.floatingLabelWrapper}`;

  return (
    <div className={`${wrapperClass} ${error ? "phone-error" : ""} ${disabled ? "phone-disabled" : ""}`} style={{ position: "relative" }}>
      <PhoneInput
        value={numberValue}
        defaultCountry={defaultCountry}
        countries={countries}
        onChange={handleChange}
        onFocus={!disabled ? onFocus : undefined}
        onBlur={!disabled ? onBlur : undefined}
        forceDialCode
        disabled={disabled}
        inputProps={{
          required: true,
          placeholder: "",
          disabled: disabled
        }}
      />

      {/* Placeholder overlays */}
      {placeholderMode === "ExampleNumber" && !nationalNumber && (
        <span className="phoneExampleOverlay">
          {placeholderText}
        </span>
      )}
      
      {placeholderMode === 'TemplateSendExampleNumber' && !nationalNumber && (
        <span className="phoneExampleOverlay" style={{ top: "50%" }}>
          {placeholderText}
        </span>
      )}

      {showHelperText && !nationalNumber && (
        <span className="phoneExampleOverlay" style={{ top: "52%" }}>
          {placeholderText}
        </span>
      )}

      {error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default InternationalPhoneInput;